/**
 * Buy-box layout: quantity beside Add to cart, dynamic checkout below.
 *
 * Sense renders the quantity selector and the buy buttons as separate, independently
 * orderable blocks — there is no single container CSS alone could reach to put the
 * quantity stepper beside the Add to cart button while keeping the dynamic checkout
 * button (Shop Pay / Buy it now) on its own full-width row below both. Moving the
 * quantity stepper into the same row as the buttons, once, on load, is simpler and more
 * robust than fighting the DOM with :has() across several nested ancestors.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form__buttons').forEach((buttons) => {
    const infoContainer = buttons.closest('.product__info-container');
    const quantity = infoContainer?.querySelector('.product-form__quantity');
    if (!quantity) return;

    buttons.classList.add('beeul-buybar');
    buttons.insertBefore(quantity, buttons.firstChild);
  });
});
